/** THIS FILE IS AUTOMATICALLY GENERATED FROM : https://api-onboarding.electra-power.co.il/swagger/v1/swagger.json **/

import axios from "../axios";
import * as Electra from "./ElectraInterfaces";
import { ReferralCode } from "./ElectraInterfaces";

export const getAccountGenerateVerificationCode = (
  mobilePhone: string,
  toSendSms: boolean = true,
) =>
  axios.get<Electra.GenerateVerificationCodeResponseResponseWrapper>(
    `/api/account/generateVerificationCode`,
    { params: { mobilePhone, toSendSms }, headers: {} },
  );

export const getAccountUpdateLastSeen = () =>
  axios.get<Electra.DateTimeResponseWrapper>(`/api/account/updateLastSeen`, {
    headers: {},
  });

export const getAccountGetUserInfo = () =>
  axios.get<Electra.UserInfoResponseResponseWrapper>(
    `/api/account/getUserInfo`,
    { headers: {} },
  );

export const postAccountVerifyUser = (data: Electra.VerifyUserRequest) =>
  axios.post<Electra.UserInfoResponseResponseWrapper>(
    `/api/account/verifyUser`,
    data,
    { headers: {} },
  );

export const postAccountRegister = (data: Electra.RegistrationRequest) =>
  axios.post<Electra.RegistrationResponseResponseWrapper>(
    `/api/account/register`,
    data,
    { headers: {} },
  );

export const postAccountLogout = () =>
  axios.post<Electra.BooleanResponseWrapper>(`/api/account/logout`, {
    headers: {},
  });

export const postAccountUpdateUserInfo = (
  data: Electra.UpdateUserInfoRequest,
) =>
  axios.post<Electra.UserInfoResponseResponseWrapper>(
    `/api/account/UpdateUserInfo`,
    data,
    { headers: {} },
  );

export const postBillingPlanGetAll = () =>
  axios.post<Electra.BillingPlanDtoListResponseWrapper>(
    `/api/billingPlan/getAll`,
    { headers: {} },
  );

export const postBillingPlanGetBillingPlan = (
  data: Electra.MobilityProcessBaseRequest,
) =>
  axios.post<Electra.BillingPlanDtoListResponseWrapper>(
    `/api/billingPlan/getBillingPlan`,
    data,
    { headers: {} },
  );

export const getSettingsAll = () =>
  axios.get<Electra.GeneralSettingResponseListResponseWrapper>(
    `/api/settings/all`,
    { headers: {} },
  );

export const postMobilityProcessGetProcessStatus = (
  data: Electra.MobilityProcessBaseRequest,
) =>
  axios.post<Electra.MobilityProcessResponeResponseWrapper>(
    `/api/mobilityProcess/getProcessStatus`,
    data,
    { headers: {} },
  );

export const postMobilityProcessStartProcess = (
  data: Electra.StartProcessRequest,
) =>
  axios.post<Electra.MobilityProcessResponeResponseWrapper>(
    `/api/mobilityProcess/startProcess`,
    data,
    { headers: {} },
  );

export const postMobilityProcessEnterOtp = (data: Electra.EnterOtpRequest) =>
  axios.post<Electra.MobilityProcessResponeResponseWrapper>(
    `/api/mobilityProcess/enterOtp`,
    data,
    { headers: {} },
  );

export const postMobilityProcessReSendOtp = (
  data: Electra.MobilityProcessBaseRequest,
) =>
  axios.post<Electra.MobilityProcessResponeResponseWrapper>(
    `/api/mobilityProcess/reSendOtp`,
    data,
    { headers: {} },
  );

export const postMobilityProcessSetBilling = (
  data: Electra.SetBillingPlanRequest,
) =>
  axios.post<Electra.MobilityProcessResponeResponseWrapper>(
    `/api/mobilityProcess/setBilling`,
    data,
    { headers: {} },
  );

export const postMobilityProcessSetApprove = (
  data: Electra.SetApproveRequest,
) =>
  axios.post<Electra.MobilityProcessResponeResponseWrapper>(
    `/api/mobilityProcess/setApprove`,
    data,
    { headers: {} },
  );

export const postPaymentGetTokenUrl = (data: Electra.GetTokenUrlRequest) =>
  axios.post<Electra.StringResponseWrapper>(`/api/payment/getTokenUrl`, data, {
    headers: {},
  });

export const postPaymentPaymentDone = (
  formData: FormData,
  onUploadProgress?: (progressEvent: any) => void,
) =>
  axios.post<Electra.PaymentDonRespone>(`/api/payment/paymentDone`, formData, {
    onUploadProgress,
    headers: { "Content-Type": "multipart/form-data" },
  });

export const handleRefcodeCheck = async (
  refcode: string,
): Promise<any | null> => {
  if (!refcode) return null;

  try {
    const response = await axios.post(`/api/billingPlan/checkRefcode`, {
    refcode,
      headers: {},
    });

    const { body } = response.data;


    const record =  body;
       console.log("record " + record)
    return {
      referralCode: record.referal_Code__c, // ✅ matches interface name
      title: record.title__c ?? "",
      subtitle: record.sub_title__c ?? "",
      campaign: record.campaign_Name__c ?? "",
      specialTerms: record.special_Terms__c ?? "",
    };
  } catch (error) {
    console.error("Refcode check error:", error);
    return null;
  }
};
